import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

export default () => (
  <Container className="text-center">
    <Row>
      <Col>
        <p>404. Not found.</p>
      </Col>
    </Row>
  </Container>
);
